import axios from "axios";

const root=process.env.SAPI_ROOT;

// baseURL.baseHost
//axios配置
axios.defaults.timeout=10000;
// axios.defaults.baseURL="http://172.30.112.101:8080/health/";
axios.defaults.headers.post["Content-Type"] =
    "application/json";

//POST传参序列化
axios.interceptors.request.use(
    config => {
        // config.headers={'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'}
        if (config.method === "post") {
           
            // config.data = qs.stringify(config.data);
            //  config.headers.post["Content-Type"]='application/json';
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

//返回状态判断
axios.interceptors.response.use(
    res => {
        return res ;
    },
    error => {
        return Promise.reject(error);
    }
);

export function post(url, params) {
    return new Promise((resolve, reject) => {
     
        axios
            .post(root+url,JSON.stringify(params))
            .then(
                response => {
                    resolve(response.data);
                },
                err => {
                    reject(err);
                }
            )
            .catch(error => {
                reject(error);
            });

    });
}

export function fetch(url,params){
    return new Promise((resolve, reject) => {
        axios
            .get(root+url, {params:params})
            .then(
                response => {
                    resolve(response.data);
                },
                err => {
                    reject(err);
                }
            )
            .catch(error => {
                reject(error);
            });

    });
}

export default{
    
    //调查问卷
    getSurvey(){
        return fetch("getSurvey");
    },
     //问卷提交
     getAnswer(userID,params){
        return post("getAnswer/"+userID,params);
    },
    //查询1+x套餐项目
    getItems(userID){
        return fetch("getItems/"+userID);
    }
}




// WEBPACK FOOTER //
// ./src/fetch/surveyApi.js